import React, { Component } from 'react';
import Sidebar from './Sidebar';
import Footer from './Footer';
import Dashboard from './../views/Dashboard';
import AccessRight from './../views/master/AccessRight';
import ProductMaster from './../views/master/ProductMaster';
import UserMaster from './../views/master/UserMaster';
import CartonMaster from './../views/master/CartonMaster';
import CompanyMaster from './../views/master/CompanyMaster';
import DealerMaster from './../views/master/DealerMaster';
import ListMaster from './../views/master/ListMaster';
import PriceMaster from './../views/master/PriceMaster';
import DistributorMaster from './../views/master/DistributorMaster';
import DeMapping from './../views/transaction/DeMapping';
import Mapping from './../views/transaction/Mapping';
import Dispatch from './../views/transaction/Dispatch';
import SecondaryPacking from './../views/transaction/SecondaryPacking';
import SecondaryDamage from './../views/transaction/SecondaryDamage';
import TertiaryPacking from './../views/transaction/TertiaryPacking';
import NumberIssued from './../views/transaction/NumberIssued';
import StockManagement from './../views/transaction/StockManagement';
import ProductDamage from './../views/transaction/ProductDamage';
import StaticMapping from './../views/transaction/StaticMapping';
import ProductConfiguration from './../views/master/ProductConfiguration';
import MappingReport from './../views/reports/MappingReport';
import VerificationReport from './../views/reports/VerificationReport';
import FeedbackReport from './../views/reports/FeedbackReport';
import DispatchReport from './../views/reports/DispatchReport';
import DispatchReturn from './../views/transaction/DispatchReturn';
import PrimaryPackingReport from './../views/reports/PrimaryPackingReport';
import SecondaryPackingReport from './../views/reports/SecondaryPackingReport';
import TertiaryPackingReport from './../views/reports/TertiaryPackingReport';
import ItemLedger from './../views/reports/ItemLedger';
import SchemeReport from './../views/reports/SchemeReport';
import RedemptionReport from './../views/reports/RedemptionReport';
import MissingCartonReport from './../views/reports/MissingCartonReport';
import DepotMaster from '../views/master/DepotMaster';
import Profile from './../views/Profile';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Logo from './../assets/images/logo.png';
import Avtar from './../assets/images/avatar.jpg';
import './../App.css';
import Message from './Message';
import SchemeMaster from '../views/master/SchemeMaster';
import SecondaryManual from '../views/transaction/SecondaryManual';
import SchemeConfiguration from '../views/transaction/SchemeConfiguration';
import Category from '../views/master/Category';
import UserService from '../services/UserService';
import NumberGeneration from '../views/transaction/NumberGeneration';
import DispatchReceive from '../views/transaction/DispatchReceive';
import WareHouseMaster from '../views/master/WareHouseMaster';
import ItemWiseStockDetail from '../views/reports/ItemWiseStockDetail';
import SecondaryManualReport from '../views/reports/SecondaryManualReport';
import QrCodeReport from '../views/reports/QrCodeReport';
import ChangePassword from '../views/ChangePassword';
import FactoryMaster from '../views/master/FactoryMaster';
import AdminNumberGenerated from '../views/transaction/AdminNumberGenerated';
import DiProduct from '../views/DiProduct';
// use for layout 
export default class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      UserName: '',
      toggle: false,
      value: null
    }

    this.UserService = new UserService();
  }
  //trigger api function on page call
  componentDidMount() {
    setTimeout(() => {
     // this.CheckIsResetPassword();
      this.getUser();
    }, 1000)
  }
  //to get user data
  getUser() {
    this.UserService.getUser().then(data => {
      const resdata = data.data;
      if (resdata.ResponseCode === '200') {
        const usr = resdata.ResponseData;
        this.setState({
          UserName: usr.Username,
          UserId: usr.UserId
        });
      }
    });
  }
  // Check Reset Password
  CheckIsResetPassword() {
    this.UserService.getUser().then((res) => {
      const curl = window.location.pathname;

      const resdata = res.data;
      //if ResponData not null
      if (resdata !== null && resdata.ResponseCode === '200' && resdata.ResponseData != null && resdata.ResponseData.IsResetPassword == true) {
        if (!curl.includes("/profile")) {
          window.location = '/profile';
        }
      } else {

      }
    });
  }

  handleChange = value => {
    this.setState({ value })
  }

  // Render HTML
  //updated  Render HTML to resolve defect KREP-12 on [08-07-20]
  render() {

    return (
      <>

        <div className={this.state.toggle ? 'row1 open' : 'row1'}>
          <div className="col-md-12">
            <div className="header-top">
              <div className="logo-section">
                <img src={Logo} alt="KREP" />

                <span id="menuToggle" onClick={() => { this.setState({ toggle: !this.state.toggle }); }} style={{ paddingLeft: "14px", fontSize: "20px" }}><i className="fa fa-bars"></i></span>

              </div>
              <div className="right-section">
                <div className="user-area dropdown" >
                  <span className="dropdown-toggle active" >Welcome, {this.state.UserName}
                    <img alt="User Avatar" className="user-avatar rounded-circle" src={Avtar} />
                  </span>
                  <div className="user-menu">
                    <div className="nav-link" ><a href="/profile"><i className="fa fa-address-card"></i>Profile</a></div>
                    <div className="nav-link"><a href="/change-password"><i className="fa fa-key"></i>Change Password</a></div>
                    <div className="nav-link" onClick={(e) => { sessionStorage.removeItem("LoggedInUser"); window.location = '/login' }}><i className="fa fa-power-off"></i>Logout</div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div className="left-panel">
            <Sidebar />
          </div>
          <div className="right-panel">
            <Router>
              <Switch>

                <Route exact path="/" component={Dashboard} />
                <Route exact path="/dashboard/" component={Dashboard} />
                <Route path="/profile/" component={Profile} />
                <Route path="/change-password/" component={ChangePassword} />
                <Route path="/masters/access-right/" component={AccessRight} />
                <Route path="/masters/product-master/" component={ProductMaster} />
                <Route path="/masters/scheme-master/" component={SchemeMaster} />
                <Route path="/masters/product-configuration" component={ProductConfiguration} />
                <Route path="/masters/user-master/" component={UserMaster} />
                <Route path="/masters/warehouse-master/" component={WareHouseMaster} />
                <Route path="/masters/factory-master/" component={FactoryMaster} />
                <Route path="/masters/carton-master/" component={CartonMaster} />
                <Route path="/masters/dealer-master/" component={DistributorMaster} />
                <Route path="/masters/list-master/" component={ListMaster} />
                <Route path="/masters/price-master/" component={PriceMaster} />
                <Route path="/masters/retailer-master/" component={DealerMaster} />
                <Route path="/masters/depot-master/" component={DepotMaster} />
                <Route path="/masters/company-master/" component={CompanyMaster} />
                <Route path="/masters/category/" component={Category} />
                <Route path="/transaction/de-mapping/" component={DeMapping} />
                <Route path="/transaction/mapping/" component={Mapping} />
                <Route path="/transaction/number-issued/" component={NumberIssued} />
                <Route path="/transaction/secondary-packing/" component={SecondaryPacking} />
                <Route path="/transaction/secondary-damage/" component={SecondaryDamage} />
                <Route path="/transaction/tertiary-packing/" component={TertiaryPacking} />
                <Route path="/transaction/product-damage/" component={ProductDamage} />
                <Route path="/transaction/dispatch/" component={Dispatch} />
                <Route path="/transaction/scheme-configuration/" component={SchemeConfiguration} />
                <Route path="/transaction/stock-management/" component={StockManagement} />
                <Route path="/transaction/number-generation/" component={NumberGeneration} />
                <Route path="/transaction/admin-number-download/" component={AdminNumberGenerated} />
                <Route path="/transaction/dispatch-receive/" component={DispatchReceive} />
                <Route path="/transaction/map-static-number/" component={StaticMapping} />
                <Route path="/transaction/secondary-manual/" component={SecondaryManual} />
                <Route path="/reports/mapping-report/" component={MappingReport} />
                <Route path="/reports/verification-report/" component={VerificationReport} />
                <Route path="/reports/feedback-report/" component={FeedbackReport} />
                <Route path="/reports/dispatch-report/" component={DispatchReport} />
                <Route path="/reports/primary-packing-report/" component={PrimaryPackingReport} />
                <Route path="/reports/secondary-packing-report/" component={SecondaryPackingReport} />
                <Route path="/reports/tertiary-packing-report/" component={TertiaryPackingReport} />
                <Route path="/reports/redemption-report/" component={RedemptionReport} />
                <Route path="/reports/scheme-report/" component={SchemeReport} />
                <Route path="/reports/item-ledger/" component={ItemLedger} />
                <Route path="/reports/stock-report/" component={ItemWiseStockDetail} />
                <Route path="/reports/qr-code-tracking-report" component={QrCodeReport} />
                <Route path="/reports/missing-carton-report/" component={MissingCartonReport} />
                <Route path="/reports/secondary-manual-report/" component={SecondaryManualReport} />
                <Route path="/transaction/dispatch-return/" component={DispatchReturn} />

                <Route path="*" component={Dashboard} />
              </Switch>
            </Router>
          </div>
          <div className="col-md-12">

            <Footer />
          </div>

          <div className="Message">
            <Message />
          </div>
        </div>

      </>
    )
  }

}

